import React from 'react';
import loadable from '@loadable/component';

import { loadData } from '../../page';
import { Helpers } from '../../core/src/helpers';

const NotFoudPage = loadable(() => Helpers.retryFunc(() => import('./not-found-page')));

export default {
    component: NotFoudPage,
    loadData: (urlParams, store, context) => {
        //funnel all error page request to a specific 404 slug
        return loadData({ dir: 'error', slug: '404' }, store, context);
    },
};
